
import { defineComponent } from "vue";
import SocialItem, { TSocialItem } from "@/components/SocialItem.vue";

export default defineComponent({
  name: "SocialList",
  components: { SocialItem },
  setup() {
    const items: TSocialItem[] = [
      {
        title: "github",
        link: "https://github.com/andreyshr/snake",
        icon: "github",
      },
    ];

    return {
      items,
    };
  },
});
